import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `tailwind-merge` doesn't natively know about Tailwind v4 `@theme inline`
 * custom utilities, so the eight Credem semantic typography tokens
 * (`text-display-l`, `text-section-title`, `text-body-default`, etc.)
 * collide with text-colour utilities like `text-foreground` and one of
 * the two gets silently dropped. Registering them in the `font-size`
 * group fixes that — `text-section-title text-foreground` now keeps both,
 * while `text-section-title text-body-default` still merges to the later
 * font-size. Same fix needed for any future tokens added to the scale.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-display-l',
        'text-display-m',
        'text-screen-title',
        'text-section-title',
        'text-body-default',
        'text-body-emphasis',
        'text-body-italic',
        'text-caption',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
